import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Fade } from 'react-awesome-reveal';
import { ProgressiveImage } from '../ProgressiveImage';
import { RadioButton } from '../RadioButton';
import { RoleSelectorMobile } from '../RoleSelectorMobile';
import { isMobile } from '../../lib/shared/dimensions';
import styles from './RoleSelectorStage.css';

const ROLES = [
    {
        id: 'leader',
        name: 'Leader'
    },
    {
        id: 'shooter',
        name: 'Shooter'
    },
    {
        id: 'defender',
        name: 'Defender'
    }
];

const cx = classnames.bind(styles);

function RoleSelectorStage({cards, selectRoleByCard, finishStage, variant}) {
    const checkRole = ({role, cardId, callback}) => () => {
        callback?.();
        selectRoleByCard(role, cardId);
    };

    const renderRadioButtons = ({card, callback}) => {
        return (
            <div className={styles.radioButtons}>
                {ROLES.map(role => (
                    <RadioButton
                        key={role.id}
                        label={role.name}
                        onClick={checkRole({role: role.id, cardId: card.id, callback})}
                        checked={card.selectedRole === role.id}
                        variant={variant}
                    />
                ))}
            </div>
        )
    };

    if (isMobile()) {
        return (
            <RoleSelectorMobile
                onComplete={finishStage}
            >
                {(currentIndex, setNextCard) => (
                    <Fade
                        key={currentIndex}
                        duration={400}
                        triggerOnce
                    >
                        <div className={styles.currentCard}>
                            <ProgressiveImage
                                alt='player'
                                src={cards[currentIndex].imageUrl}
                                className={styles.cardImage}
                            />
                            {renderRadioButtons({card: cards[currentIndex], callback: setNextCard})}
                        </div>
                    </Fade>
                )}
            </RoleSelectorMobile>
        )
    };

    return (
        <div className={cx('cards', {[variant]: Boolean(variant)})}>
            {cards.map(card => (
                <div
                    className={styles.card}
                    key={card.id}
                >
                    <ProgressiveImage
                        alt='player'
                        src={card.imageUrl}
                        className={styles.cardImage}
                    />
                    {renderRadioButtons({card})}
                </div>
            ))}
        </div>
    );
};

RoleSelectorStage.propTypes = {
    cards: PropTypes.array.isRequired,
    selectRoleByCard: PropTypes.func.isRequired,
    finishStage: PropTypes.func.isRequired,
    variant: PropTypes.string
};

RoleSelectorStage.defaultProps = {
    variant: 'primary'
};

export {
    RoleSelectorStage
};
